if (!customElements.get('tb-video-gallery')) {
  customElements.define('tb-video-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const track = this.querySelector('.tb-video-track');
      if (!track) return;
      const buttons = this.querySelectorAll('[data-direction]');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        buttons.forEach(button => {
          button.disabled = button.dataset.direction === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const card = track.querySelector('.tb-video-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: Number(button.dataset.direction) * (card.offsetWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options));
      this.querySelectorAll('video').forEach(video => video.addEventListener('play', () => {
        this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      }, options));
      track.addEventListener('scroll', update, { ...options, passive: true });
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, options);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
}
